import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Clock, LogOut, Shield } from "lucide-react";

// Neutral native "trial ended" screen. Deliberately contains NO price, Subscribe button, Stripe
// branding, website/purchase link, QR code or external purchasing instructions. Existing paid
// subscribers never reach this screen (server entitlement keeps them allowed). Account/data and
// deletion remain reachable via Privacy & Data.
export default function AccessEnded() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div className="df-shell df-safe-top min-h-screen flex flex-col justify-center px-6 py-10" data-testid="access-ended">
      <div className="df-fade-in w-full max-w-md mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <img src="/molaroo-mark.png" alt="Molaroo" className="h-14 w-14 rounded-2xl object-contain bg-white shadow-sm" />
          <div>
            <div className="text-2xl font-heading font-bold tracking-tight text-slate-900 leading-none">Molaroo</div>
            <div className="text-sm text-slate-500 mt-1">Your income, organised.</div>
            <div className="text-xs text-slate-400 mt-0.5">by NavScora</div>
          </div>
        </div>

        <div className="df-card p-6 text-center">
          <span className="mx-auto h-12 w-12 rounded-full bg-[#E6F4F1] text-[#0D786A] flex items-center justify-center mb-4">
            <Clock size={22} />
          </span>
          <h1 className="text-2xl font-bold tracking-tight text-slate-900 mb-1" data-testid="access-ended-title">
            Your free trial has ended
          </h1>
          <p className="text-slate-500 text-sm leading-relaxed">
            Your Molaroo trial period is complete, so premium access on this device is paused.
            Your data is safe and stays on your account.
          </p>
          <p className="text-slate-500 text-sm leading-relaxed mt-3">
            You can still review your account details, export your data, or delete your account.
          </p>

          <Button data-testid="access-ended-account" onClick={() => navigate("/more/privacy")}
            className="w-full h-11 rounded-xl bg-[#0D786A] hover:bg-[#0A6055] mt-5 df-pressable">
            <Shield size={16} className="mr-1.5" /> Account &amp; data
          </Button>
          <button data-testid="access-ended-signout" onClick={logout}
            className="w-full text-sm text-slate-500 mt-3 df-pressable inline-flex items-center justify-center gap-1">
            <LogOut size={14} /> Sign out
          </button>
        </div>

        <p className="text-center text-[11px] text-slate-300 mt-4">Molaroo · by NavScora</p>
      </div>
    </div>
  );
}
